"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SearchSelect = void 0;
var react_1 = __importStar(require("react"));
var lodash_1 = require("lodash");
var core_1 = require("@blueprintjs/core");
var SearchSelectItems_1 = require("./SearchSelectItems");
var SelectSelectionInfo_1 = require("./SelectSelectionInfo");
var mobx_react_1 = require("mobx-react");
var SearchSelectStore_1 = require("./SearchSelectStore");
var styled_1 = require("./styled");
var Tooltip = core_1.Tooltip;
var Popover = core_1.Popover;
exports.SearchSelect = (0, mobx_react_1.observer)(function (props) {
    var _a;
    var _b = (0, mobx_react_1.useLocalStore)(function () {
        return new SearchSelectStore_1.SearchSelectStore(props.popoverWidth || props.fixedInputWidthPx || 150);
    }), options = _b.options, search = _b.search, popoverWidth = _b.popoverWidth, invokeKeyPress = _b.invokeKeyPress, enableFilter = _b.enableFilter, isOpen = _b.isOpen, selection = _b.selection, hasChange = _b.hasChange, displayTooltip = _b.displayTooltip, arrayOfValues = _b.arrayOfValues, hideToolTip = _b.hideToolTip, setSearch = _b.setSearch, setInvokeKeyPress = _b.setInvokeKeyPress, setEnableFilter = _b.setEnableFilter, setPopoverWidth = _b.setPopoverWidth, setSelection = _b.setSelection, setIsOpen = _b.setIsOpen, setOptions = _b.setOptions, handleIsOpen = _b.handleIsOpen, setHasChange = _b.setHasChange, showTooltipWithDisabled = _b.showTooltipWithDisabled;
    var findOptionsValue = function (options, value) {
        return (0, lodash_1.find)(options, function (v) {
            return !(0, lodash_1.isNil)(v === null || v === void 0 ? void 0 : v.value) &&
                !(0, lodash_1.isNil)(value) &&
                v.value.toString() === value.toString();
        });
    };
    (0, react_1.useEffect)(function () {
        var _a;
        if (props.multi && !(0, lodash_1.isArray)(props.value)) {
            throw new Error('Multi Select value must be an array');
        }
        if (!props.multi && props.value !== '') {
            var option = findOptionsValue(props.options, props.value);
            !!(option === null || option === void 0 ? void 0 : option.label) && setSearch(option.label.toString());
        }
        else if (!props.multi && !props.value) {
            clearSearch();
        }
        else if (props.multi && !((_a = props.value) === null || _a === void 0 ? void 0 : _a.length)) {
            clearSearch();
        }
        setSelection(props.value);
    }, [props.value, props.options]);
    (0, react_1.useEffect)(function () {
        props.multi && !!getSelectionLength() && initValueStateMulti(isOpen);
    }, [selection]);
    (0, react_1.useEffect)(function () {
        props.popoverWidth && setPopoverWidth(props.popoverWidth);
    }, [props.popoverWidth]);
    (0, react_1.useEffect)(function () {
        var w = 150;
        var opt = props.options.filter(function (value) {
            var _a;
            try {
                var factor = !props.multi ? 6.8 : 7.8;
                var lw = (value === null || value === void 0 ? void 0 : value.label) ? value.label.toString().length * factor : 100;
                if (lw > w) {
                    w = lw;
                }
                if ((0, lodash_1.isNil)(value.value) || (0, lodash_1.isNil)(value.label)) {
                    return false;
                }
                return (value.label
                    .toString()
                    .toLowerCase()
                    .indexOf(search.toLowerCase()) !== -1 ||
                    ((value === null || value === void 0 ? void 0 : value.additionalSearchText) &&
                        ((_a = value.additionalSearchText
                            .toString()
                            .toLowerCase()) === null || _a === void 0 ? void 0 : _a.indexOf(search.toLowerCase())) !== -1) ||
                    !enableFilter);
            }
            catch (_b) {
                return false;
            }
        });
        if (props.sort && !props.displayAsTree) {
            opt = (0, lodash_1.orderBy)(opt, ['label'], [props.sort]);
        }
        setOptions(opt);
        !props.popoverWidth && setPopoverWidth(w + 30);
    }, [props.options, search]);
    (0, react_1.useEffect)(function () {
        var deselect = function (isKeyDeletedPressed) {
            if (isKeyDeletedPressed === void 0) { isKeyDeletedPressed = false; }
            if (isOpen && isKeyDeletedPressed) {
                var reset = !props.allowEmpty && !props.multi
                    ? selection
                    : (props === null || props === void 0 ? void 0 : props.multi)
                        ? (0, lodash_1.isArray)(selection) && !!selection.length
                            ? selection
                            : []
                        : '';
                setSelection(reset);
                if (!!reset) {
                    setEnableFilter(false);
                    setIsOpen(true);
                }
                props.onChange && props.onChange(reset);
            }
        };
        if (search.length === 0) {
            deselect();
        }
        if (invokeKeyPress !== 'NONE') {
            if (invokeKeyPress === core_1.Keys.DELETE) {
                deselect(true);
                setSearch('');
            }
        }
    }, [search, invokeKeyPress]);
    var clearSearch = function () {
        setSearch('');
    };
    var onSearchChange = function (e) {
        !isOpen && setIsOpen(true);
        setEnableFilter(true);
        setSearch(e.target.value);
    };
    var setSearchSelectionText = function (value) {
        var option = findOptionsValue(props.options, value);
        (option === null || option === void 0 ? void 0 : option.label)
            ? setSearch(option.label.toString())
            : !(0, lodash_1.isNil)(value) && setSearch(value.toString());
    };
    var handleInteraction = function (nextOpenState, e) {
        var _a, _b, _c, _d, _e, _f;
        try {
            if (!(props === null || props === void 0 ? void 0 : props.isLoading)) {
                if (e && !props.disabled) {
                    if (((_b = (_a = e.target.parentNode) === null || _a === void 0 ? void 0 : _a.className) === null || _b === void 0 ? void 0 : _b.indexOf('gsi-input-select')) !==
                        -1 ||
                        ((_d = (_c = e.target.parentNode) === null || _c === void 0 ? void 0 : _c.className) === null || _d === void 0 ? void 0 : _d.indexOf('gsi-selection-caret')) !==
                            -1) {
                        setIsOpen(nextOpenState);
                        !nextOpenState && !props.multi && onChangeItems(selection);
                        !props.multi &&
                            selection &&
                            setSearchSelectionText(selection || '');
                        return;
                    }
                    if (e.target.className.indexOf('gsi-selection-info-deselect') !== -1) {
                        setIsOpen(false);
                        return;
                    }
                    if (e.currentTarget.className &&
                        ((_f = (_e = e.currentTarget) === null || _e === void 0 ? void 0 : _e.className) === null || _f === void 0 ? void 0 : _f.indexOf('gsi-select-popover')) !== -1) {
                        setIsOpen(props.multi ? props.multi : false);
                        return;
                    }
                }
                !props.disabled && setIsOpen(nextOpenState);
                !nextOpenState && !props.multi && onChangeItems(selection);
                initValueStateMulti(nextOpenState);
                !props.multi && selection && setSearchSelectionText(selection || '');
                !props.multi && options.length === 0 && clearSearch();
            }
        }
        catch (e) {
            !props.disabled && setIsOpen(nextOpenState);
        }
    };
    var initValueStateMulti = function (nextOpenState) {
        if (nextOpenState === void 0) { nextOpenState = false; }
        props.multi && resetStateMulti();
        props.multi && handleUpdateSearchText(nextOpenState);
    };
    var resetStateMulti = function () {
        var _a, _b;
        if (props.multi && (selection === null || selection === void 0 ? void 0 : selection.length) === 1) {
            var options_1 = props.options;
            var elementSelect = (0, lodash_1.find)(options_1, function (item) { return item.value === selection[0]; });
            var elementSelectLabel = (_a = elementSelect === null || elementSelect === void 0 ? void 0 : elementSelect.label) !== null && _a !== void 0 ? _a : '';
            if (elementSelectLabel !== search) {
                setSearch(elementSelectLabel);
                setEnableFilter(false);
            }
        }
        else if (props.multi && !((_b = props === null || props === void 0 ? void 0 : props.value) === null || _b === void 0 ? void 0 : _b.length) && !selection.length) {
            clearSearch();
        }
    };
    var onChangeItems = function (selection) {
        var _a;
        (_a = props.onChange) === null || _a === void 0 ? void 0 : _a.call(props, selection);
    };
    var shouldUpdateOnClose = function () {
        return (props.multi && !props.getValueOnSelectMenuItem && !isOpen && !hasChange);
    };
    var deselectAllItems = function () {
        var _a;
        setSelection([]);
        (_a = props.onChange) === null || _a === void 0 ? void 0 : _a.call(props, []);
    };
    var selectDeselectItem = function (value) {
        var _a;
        if (props.multi && (0, lodash_1.isArray)(selection)) {
            var selected = (0, lodash_1.cloneDeep)(selection);
            if (selection.includes(value.value)) {
                (0, lodash_1.remove)(selected, function (val) { return val === value.value; });
            }
            else {
                selected.push(value.value);
            }
            setEnableFilter(false);
            clearSearch();
            setSelection(selected);
            if (props.getValueOnSelectMenuItem) {
                (_a = props.onChange) === null || _a === void 0 ? void 0 : _a.call(props, selected);
            }
        }
        else {
            setSelection(value.value);
            setEnableFilter(false);
            if (!value.value && props.allowEmpty)
                clearSearch();
        }
        !props.multi && (value === null || value === void 0 ? void 0 : value.label) && setSearch(value.label.toString());
    };
    var getSelectionLength = function () {
        if (props.multi && (0, lodash_1.isArray)(selection)) {
            return selection.length;
        }
        return 0;
    };
    var onKeyPress = function (e) {
        var keyCode = e.keyCode;
        if (keyCode === core_1.Keys.ARROW_UP ||
            keyCode === core_1.Keys.ARROW_DOWN ||
            keyCode === core_1.Keys.ENTER ||
            keyCode === core_1.Keys.DELETE) {
            setInvokeKeyPress(keyCode);
            setTimeout(function () {
                setInvokeKeyPress('NONE');
            }, 10);
        }
    };
    var onAddNewItem = function () {
        props.onAddNewItem && props.onAddNewItem(search);
        setIsOpen(false);
        clearSearch();
    };
    var handleUpdateSearchText = function (state) {
        var _a, _b, _c;
        if (!state && (selection === null || selection === void 0 ? void 0 : selection.length) === 1) {
            var option = (_c = (_b = (_a = findOptionsValue(props.options, selection[0])) === null || _a === void 0 ? void 0 : _a.label) === null || _b === void 0 ? void 0 : _b.toString) === null || _c === void 0 ? void 0 : _c.call(_b);
            setSearch(option || '');
            return;
        }
        clearSearch();
    };
    var onClose = function () {
        if (shouldUpdateOnClose()) {
            setHasChange(true);
            onChangeItems(selection);
        }
    };
    var onOpened = function () {
        setHasChange(false);
    };
    return (react_1.default.createElement(Popover, { targetClassName: 'gsi-select-popover', popoverClassName: 'bp3-select-popover gsi-select-popover', enforceFocus: false, isOpen: isOpen, autoFocus: false, canEscapeKeyClose: true, captureDismiss: true, minimal: props.popoverMinimal, interactionKind: core_1.PopoverInteractionKind.CLICK, modifiers: {
            flip: { enabled: true },
            keepTogether: { enabled: true },
            preventOverflow: { enabled: true }
        }, onInteraction: handleInteraction, shouldReturnFocusOnClose: false, onClose: onClose, onOpened: onOpened },
        react_1.default.createElement("div", { onKeyUpCapture: onKeyPress, onMouseOver: showTooltipWithDisabled(!props.displayValueTooltip), onMouseLeave: hideToolTip },
            react_1.default.createElement(Tooltip, { isOpen: displayTooltip, content: !props.multi ? (arrayOfValues === null || arrayOfValues === void 0 ? void 0 : arrayOfValues[0]) : (react_1.default.createElement(styled_1.StyledUl, null, arrayOfValues.map(function (val, index) { return (react_1.default.createElement("li", { key: index }, val)); }))) },
                react_1.default.createElement(core_1.InputGroup, { autoFocus: false, className: !props.isLoading
                        ? "gsi-input-select ".concat(props.multi ? 'gsi-input-multi-select' : '')
                        : core_1.Classes.SKELETON, disabled: props.disabled, rightElement: react_1.default.createElement(SelectSelectionInfo_1.SelectSelectionInfo, { disabled: props.disabled ? props.disabled : false, count: getSelectionLength(), multi: !!props.multi, deselectAllItems: deselectAllItems }), onChange: onSearchChange, placeholder: (_a = props === null || props === void 0 ? void 0 : props.placeholder) !== null && _a !== void 0 ? _a : 'Search', value: search }))),
        react_1.default.createElement("div", { style: {
                width: popoverWidth,
                position: 'relative',
                maxWidth: 400
            }, onKeyUpCapture: onKeyPress },
            react_1.default.createElement(SearchSelectItems_1.SearchSelectItems, { options: options, multi: props.multi, selection: selection, selectDeselectItem: selectDeselectItem, invokeKeyPress: invokeKeyPress, search: search, allowNewItem: !!props.allowNewItem, onAddNewItem: onAddNewItem, allowEmpty: props.allowEmpty, onKeyPressed: handleIsOpen(!props.allowEmpty && !props.multi), displayAsTree: props.displayAsTree, treeChildIndentWidth: props.treeChildIndentWidth }))));
});
